/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Count
 */
export interface Count {
    /**
     * 
     * @type {number}
     * @memberof Count
     */
    count: number;
}

export function CountFromJSON(json: any): Count {
    return CountFromJSONTyped(json, false);
}

export function CountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Count {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function CountToJSON(value?: Count | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
    };
}


